import type { FetchModelResponse } from '@cian/http-api';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import type { IGetNewbuildingsSummaryResponse } from '../../../repositories/property-comparison/entities/v1_get_newbuildings_summary/GetNewbuildingsSummaryResponse';
import type { TGetNewbuildingsSummaryResponse } from '../../../repositories/property-comparison/v1/get-newbuildings-summary';

export function assertGetNewbuildingsSummaryError(
  response: TGetNewbuildingsSummaryResponse,
): asserts response is FetchModelResponse<200, 'json', IGetNewbuildingsSummaryResponse> {
  if (response.statusCode === 200) {
    return;
  }

  throw new HttpBadStatusCodeError({
    domain: 'src/shared/services/newbuildingsSummary/fetchNewbuildingsSummary.ts',
    statusCode: response.statusCode,
  });
}
